import * as React from "react";
import uhaulStore from "../CustomRedux/UhaulStore";

export class FaxButton extends React.Component {

    componentDidMount() {
        var $myWebComponent = document.getElementById("faxCompSetting");
        var shadowRoot = $myWebComponent.shadowRoot;

        if (shadowRoot && shadowRoot.children) {
            for (var i = 0; i < shadowRoot.children.length; i++) {
                var parent = shadowRoot.children[i];
                for (var j = 0; j < parent.children.length; j++) {
                    var childParent = parent.children[j];
                    if (childParent.className === "Faxbutton") {
                        childParent.setAttribute("style", "left:2px !important; background-color: white !important;position:fixed !important;");
                    }

                    var foundTextFeedbacks = [];
                    foundTextFeedbacks.push(childParent.querySelectorAll("* #file-upload-value"));
                    foundTextFeedbacks.push(childParent.querySelectorAll("* #file-fax-status"));
                    if(foundTextFeedbacks && foundTextFeedbacks.length > 0){
                        for (var x = 0; x < foundTextFeedbacks.length; x++) {
                            if(foundTextFeedbacks[x])
                            {
                                var foundText = foundTextFeedbacks[x][0];
                                if(foundText)
                                {
                                    foundText.setAttribute("style", "color: black !important;");
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    render() {
        const currentUser = uhaulStore.getState().UhaulReducer.currentUser;
        if(currentUser && currentUser.friendlyName)
        {
            var environmentIndicator = "dev";
            var currentURL = window.location.href.toString();
            if (currentURL.includes("uhaul")) //if on a uhaul site
            {
                if (currentURL.includes("chat.")) //if prod
                {
                    environmentIndicator = "prod";
                }
            }

            return (<div>
                <fax-form id="faxCompSetting" environment={environmentIndicator} appsource="1db45396-4365-4de4-bf3f-e88ac6e90c77" smid={currentUser.friendlyName} ></fax-form>
            </div>)
        }
        else{
            return null;
        }
    }
}
